import { BASE_URL, CHECK_PHONE, LOGIN, REFRESH_TOKEN, VERIFY_OTP } from "constants/api";
import axios from "axios";
import { LocalStorage } from "enums/localStorage";

export async function signIn(params: any) {
   const body: any = {
    phoneNumber: params.data.phoneNumber,
    CountryCode: params.data.CountryCode || '+966',
  };

  // ✅ add ByPassTrainer only if it exists in params.data
  if (params.data.ByPassTrainer) {
    body.ByPassTrainer = true;
  }

  const response = await axios.post(BASE_URL + LOGIN, body);
  return response.data;
}

export async function checkPhoneExists(phoneNumber: string, countryCode: string) {
  const response = await axios.post(BASE_URL + CHECK_PHONE, {
    phoneNumber,
    countryCode,
  });
  return response.data;
}
export async function verifyCode(params: any) {
  const response = await axios.post(BASE_URL + VERIFY_OTP, {
    code: params.data.code,
    phoneNumber: params.data.phoneNumber,
  });
  return response.data;
}

// Refresh token function
export const getRefreshToken = async (): Promise<{
  token: string;
  refreshToken: string;
}> => {
  const refreshToken = localStorage.getItem(LocalStorage.REFRESH_TOKEN);
  if (!refreshToken) {
    throw new Error("No refresh token available");
  }

  const response = await axios.get(
    BASE_URL + REFRESH_TOKEN + `?refreshToken=${refreshToken}`
  );

  return response.data;
};

// export async function authGuard() {
//   const token = localStorage.getItem(LocalStorage.ACCESS_TOKEN);
//   if (!token) throw new Error("Token not found");
//   const response = await axios.get(
//     BASE_URL + REFRESH_TOKEN + "?refreshToken=" + token
//   );
//   return response.data.user;
// }
